export default "__VITE_ASSET__BAFUJuuf__"